






















import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { FolderPostSettings } from "@/services/posts/postTypes/folder";

@Component
export default class FolderSettings extends Vue {
    @Prop() postSettings!: FolderPostSettings;
    @Prop() styleOptions!: Style[];
    @Prop() isNew!: boolean;

    defaultValues = { styleId: "", allowCaption: true } as FolderPostSettings;
    localPostSettings = { ...this.defaultValues, ...JSON.parse(JSON.stringify(this.postSettings)) } as FolderPostSettings;

    mounted() {
        this.setDefaultStyle();
    }

    setDefaultStyle() {
        const styles = this.styleOptions.filter(x => x.id); // Exclude the "no style" option
        if (styles.length > 0 && this.isNew) {
            const defaultStyle = styles.filter(x => x.name.toLowerCase().includes("default"))[0];
            this.localPostSettings.styleId = defaultStyle ? defaultStyle.id : styles[0].id;
        }
    }

    emitData() {
        this.$emit("allowedPostSettingsUpdated", this.localPostSettings);
    }
}
